import axios from 'axios';

export const EXPRESS_URL = 'https://aetherforgeexpressserver.onrender.com/'; //'http://localhost:7070';

const axiosExpress = axios.create({
  baseURL: EXPRESS_URL,
});

// Optional: global response error handling
axiosExpress.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Dispatch a custom event that your auth provider can listen to
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default axiosExpress;